import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import env from '../../../../util/env';
import MotifInput from '@ey/motif-react-wrapper/Input';
import MotifFormField from '@ey/motif-react-wrapper/FormField';
import MotifErrorMessage from '@ey/motif-react-wrapper/ErrorMessage';
import MotifSelect from '@ey/motif-react-wrapper/Select';
import MotifOption from '@ey/motif-react-wrapper/Option';
import MotifLabel from '@ey/motif-react-wrapper/Label';
import MotifButton from '@ey/motif-react-wrapper/Button';
import Ellipse from '@ey/canvascoreservices/Ellipse';
import EditUserPermissionsWrapper from '../styles/edituserpermissionstyle';
import SelectDropdown from '../../../Common/SelectDropdown/SelectDropdown';
import Permissions from '../../../Common/Permission/Permissions';
import { labels } from '../../../../util/uiconstants';
import Loader from '../../../Common/Loaders/loadingindicator';
import {
	getRbacRoles,
	updateInternalUser
} from '../../../../actions/admin/engagement/engagementActions';
import { UserERPTypeId, rbacRoleKeys } from '../../../../util/uiconstants';
import Toast from '../../../Common/Toast/Toast';
import { getLocalizedAPIError, validateTicketNumber } from '../../common/util';
import { EngagementStatus, engagementUserStatus, IndependenceStatus } from '../../../../util/enumerations';
import TicketField from '../../common/ticketfield';
import EllipsesControl from '../../../Common/EllipsesControl/EllipsesControl';

const formatOptionLabel = ({ value, label }) => (
	<Ellipse content={label} tooltip={label} noOfLines={1} />
);

function EngagementEditUser(props) {
	const dispatch = useDispatch();
	const [isLoading, setIsLoading] = useState(false);
	const [selectedUserStatus, setSelectedUserStatus] = useState();
	const [
		selectedIndependenceStatus,
		setSelectedIndependenceStatus
	] = useState();
	const [confidentialityType, setConfidentialityType] = useState();
	const [allFieldsDisabled, setAllFieldsDisabled] = useState(false);
	const [refreshPermissionKey, setRefreshPermissionKey] = useState(0);
	const [updatedUserPermissions, setUpdatedUserPermissions] = useState([]);
	const [errorMessage, setErrorMessage] = useState('');
	const [engagementUserStatusOptions, setEngagementUserStatusOptions] = useState([]);
	const [engagementIndependenceOption, setEngagementIndependenceOption] = useState([]);
	const rbacRoleList = useSelector((state) => state.rbacRoles);
	const [ticketNumber, setTicketNumber] = useState('');
	const [isSubmitClicked, setIsSubmitClicked] = useState(false);
	const [confidentialityDropdownDisabled, setConfidentialityDropdownDisabled] = useState(false);

	//Set default selected values for respected drop down lists.
	useEffect(() => {
		if (props?.userStatusesDDOptions) {
			var selectedUserStatusItem = props?.userStatusesDDOptions.filter(
				(ee) =>
					ee.value == props?.editUserPermissionsItem?.engagementUserStatusId
			);
			if (selectedUserStatusItem)
				setSelectedUserStatus(selectedUserStatusItem[0].value);

			let userStatus = props?.userStatusesDDOptions?.filter(
				(status) => status.value === engagementUserStatus.Active ||
					status.value === engagementUserStatus.DeActivated
			);
			setEngagementUserStatusOptions(userStatus);
		}

		if (props?.independenceStatusesDDOptions) {
			var selectedIndependenceStatusItem = props?.independenceStatusesDDOptions.filter(
				(ee) => ee.value == props?.editUserPermissionsItem?.independenceStatusId
			);
			if (selectedIndependenceStatusItem)
				setSelectedIndependenceStatus(selectedIndependenceStatusItem[0].value);

			let userStatus = props?.independenceStatusesDDOptions?.filter(
				(status) => status.value === IndependenceStatus.Incomplete
			);
			setEngagementIndependenceOption(userStatus);
		}

		var confidentialityTypes = props?.confidentialityTypes.filter(
			(ee) =>
				ee.label.toLowerCase() ==
				props?.editUserPermissionsItem?.confidentiality.toLowerCase()
		);
		if (confidentialityTypes.length) {
			setConfidentialityType(confidentialityTypes[0].value);
		}

		if (props?.editUserPermissionsItem?.userRoles?.findIndex((role) => role.roleKey == rbacRoleKeys.IndependenceOnlyRole) !== -1) {
			setConfidentialityDropdownDisabled(true);
		}
	}, [props]);

	// Use effect to call api to get all rbac roles.
	useEffect(() => {
		if (!(rbacRoleList && rbacRoleList.length > 0)) {
			getRabcRolesFromAPI();
		}
	}, []);

	const getRabcRolesFromAPI = () => {
		setIsLoading(true);
		const serviceUrlV2 = 'serviceUrlV2';
		const securityRoles = 'SecurityRoles';
		let requestsurl = env.getURL(serviceUrlV2) + securityRoles;
		dispatch(getRbacRoles(requestsurl))
			.then(() => {
				setIsLoading(false);
			})
			.catch((e) => {
				setIsLoading(false);
			});
	};

	const onUserStatusChnage = (e) => {
		setSelectedUserStatus(e);
	};

	const onIndependenceStatuseChnage = (e) => {
		setSelectedIndependenceStatus(e);
	};

	const onConfidentialityTypeChange = (c) => {
		setConfidentialityType(c);
	};

	//TODO - API call on save button click
	const onSaveButtonclick = () => {
		if (validateTicketNumber(ticketNumber)) {
			let engagementUserStatusId = selectedUserStatus;
			let independenceStatusId = selectedIndependenceStatus;

			let confTypeId =
				confidentialityType !== undefined ? confidentialityType : 0;

			let updatedUserRoles = updatedUserPermissions
				.filter((item) => item.checked)
				.map((r) => r.id);

			if (confTypeId && confTypeId > 0) {
				rbacRoleList.map((r) => {
					if (r.roleKey == confTypeId) {
						updatedUserRoles.push(r.id);
					}
				});
			}

			let userData = {
				userId: props?.editUserPermissionsItem?.userId,
				engagementUserStatusId: engagementUserStatusId,
				independenceStatusId: independenceStatusId,
				updatedUserRoles: updatedUserRoles,
				ticketNumber: ticketNumber
			};

			console.log(userData);

			const url =
				env.getURL('serviceUrlV2') +
				'admin/subservicelines/' +
				props?.ssl +
				'/countries/' +
				props?.countryId +
				'/Engagements/' +
				props?.engagementId +
				'/Users/' +
				props?.editUserPermissionsItem?.userId;

			setIsLoading(true);
			dispatch(updateInternalUser(url, userData))
				.then(() => {
					setIsLoading(false);
					props.setSuccessMessage(labels.engagementUpdateSuccess);
					props.closeModal(true);
				})
				.catch((error) => {
					var localError = getLocalizedAPIError(error);
					setErrorMessage(localError);
					setIsLoading(false);
				})
				.finally(() => {
					setIsLoading(false);
				});
		}
		else {
			setIsSubmitClicked(true);
		}
	};

	const isDisabledEngUserStatusDD = () => {
		var userEditItem = props?.editUserPermissionsItem;
		if (!props?.editPermission) {
			return true;
		} else if (props?.engagementStatusId == EngagementStatus.Archived && userEditItem.engagementUserStatusId == engagementUserStatus.Active && userEditItem.isPostArchiveAddition == false) {
			return true;
		}
		return false;
	}

	function handlerOnTicketEntered(e) {
		setTicketNumber(e.target.value)
	}

	const showErrorMsg = () => {
		return (!validateTicketNumber(ticketNumber) && isSubmitClicked);
	};

	return (
		<EditUserPermissionsWrapper>
			{isLoading == true ? (
				<Loader show view="blockView" styleName="Userloadingstyle" />
			) : (
				<section>
					<section className="addmemberwrapper customScrollbar">
						<section
							className="toastMessage"
							style={{display: errorMessage.length > 0 ? 'block' : 'none'}}
						>
							<Toast
								variant="error"
								onClose={() => {
									setErrorMessage('');
								}}
							>
								{errorMessage}
							</Toast>
						</section>
						<section className="addmemberholder">
							<section className="mainTitle motif-body1-default-light">
								{labels.EditUserPermissionsMainTitle}
							</section>
							<section className="status-independence-form">
								<MotifFormField>
									<MotifLabel id="status-label" position="in">
										{labels.EngagementUserStatus}
									</MotifLabel>
									<MotifSelect
										ariaLabelledBy="select-user-status"
										labelPosition="in"
										onChange={(e) => onUserStatusChnage(e)}
										value={selectedUserStatus && selectedUserStatus.toString()}
										disabled={isDisabledEngUserStatusDD()}
									>
										{engagementUserStatusOptions &&
											engagementUserStatusOptions?.map((item) => (
												<MotifOption
													key={item.value}
													value={item.value.toString()}
													label={item.label}
												>
													<EllipsesControl content={item.label} tooltip={item.label} noOfLines={1} />
												</MotifOption>
											))}
									</MotifSelect>
								</MotifFormField>
								<MotifFormField>
									<MotifLabel id="independence-label" position="in">
										{labels.IndependenceStatus}
									</MotifLabel>
									<MotifSelect
										ariaLabelledBy="select-independence"
										labelPosition="in"
										onChange={(e) => onIndependenceStatuseChnage(e)}
										value={
											selectedIndependenceStatus &&
											selectedIndependenceStatus.toString()
										}
										disabled={!props?.editPermission}
									>
										{engagementIndependenceOption &&
											engagementIndependenceOption?.map((item) => (
												<MotifOption
													key={item.value}
													value={item.value.toString()}
													label={item.label}
												>
													<EllipsesControl content={item.label} tooltip={item.label} noOfLines={1} />
												</MotifOption>
											))}
									</MotifSelect>
								</MotifFormField>
							</section>
							<section className="confidentiality">
								<MotifFormField>
									<MotifLabel id="confidentiality-label" position="in">
										{labels.Confidentiality}
									</MotifLabel>
									<MotifSelect
										ariaLabelledBy="select-confidentiality"
										labelPosition="in"
										onChange={(e) => onConfidentialityTypeChange(e)}
										value={
											confidentialityType && confidentialityType.toString()
										}
										disabled={
											!props?.editPermission || confidentialityDropdownDisabled
										}
									>
										{props?.confidentialityTypes?.map((item) => (
											<MotifOption
												key={item.value}
												value={item.value.toString()}
												label={item.label}
											>
												<EllipsesControl content={item.label} tooltip={item.label} noOfLines={1} />
											</MotifOption>
										))}
									</MotifSelect>
								</MotifFormField>
							</section>
							<section className="user-confid-permission">
								<Permissions
									key={refreshPermissionKey}
									rbacRoleList={rbacRoleList}
									disabled={allFieldsDisabled}
									userRoles={props?.editUserPermissionsItem?.userRoles ?? null}
									isThirdPartyUser={
										props?.editUserPermissionsItem?.userType ===
										UserERPTypeId.ThirdPartyUser
											? true
											: false
									}
									updatedUserPermissions={setUpdatedUserPermissions}
									isEditMode={true}
									canEditPermission={props?.editPermission}
									setConfidentialityDropdownDisabled={
										setConfidentialityDropdownDisabled
									}
								/>
							</section>
							<section>
								<TicketField
									ticketNumber={ticketNumber}
									onTicketChanged={handlerOnTicketEntered}
									showValidation={isSubmitClicked}
								/>
							</section>
						</section>
					</section>
					<section className="motif-modal-footer footermsg">
						<section className="requiredtext">
							{showErrorMsg()  && (
								<MotifErrorMessage>
									{labels.messageSubmitValidationError}
								</MotifErrorMessage>
							)}
						</section>
						<section className="footer-btn">
							<MotifButton
								variant="ghost"
								name="cancel"
								value="back"
								size="medium"
								onClick={() => {
									props.closeModal();
								}}
								className=""
							>
								{labels.PermissionCancelButtonText}
							</MotifButton>
							<MotifButton
								variant="primary"
								name="invite"
								value="back"
								size="medium"
								onClick={onSaveButtonclick}
								className=""
							>
								{labels.PermissionSaveButtonText}
							</MotifButton>
						</section>
					</section>
				</section>
			)}
		</EditUserPermissionsWrapper>
	);
}

export default EngagementEditUser;
